import { useMediaQuery, useTheme } from '@mui/material';
import { Fragment } from 'react/jsx-runtime';

import { UserListDesktopLayout } from './layouts/desktop';
import { UserListMobileLayout } from './layouts/mobile';

export function UserListLayout() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'), {
    noSsr: true,
  });

  return (
    <Fragment>
      {isMobile ? <UserListMobileLayout /> : <UserListDesktopLayout />}
    </Fragment>
  );
}
